import { render, staticRenderFns } from "./quarantor-info.vue?vue&type=template&id=10cb2d7b&"
import script from "./quarantor-info.vue?vue&type=script&lang=js&"
export * from "./quarantor-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports